import request from "@/shared/api/request";

export type TransferPlace = { id: number; name: string; region: number };
export type TransferEntry = {
  id: number;
  date: string;
  comment: string;
  resource_id: number;
  resource_number: string;
  resource_name: string;
  project_id: number | null;
  special_place_id: number | null;
  erfasser_id: number | null;
  original_project_id: number | null;
  original_special_place_id: number | null;
  original_erfasser_id: number | null;
  source_name: string;
  source_number: string;
  target_name: string;
  target_number: string;
  erfasser_name: string;
  original_erfasser_name: string;
  incoming: boolean;
  blocked_reason: string | null;
  current_location: { name: string; number: string; type: "project" | "specialPlace" | "freeText" } | null;
};
export type TransferAction = {
  action: "return" | "forward";
  project?: number | null;
  specialPlace?: number | null;
  erfasser?: number | null;
  comment?: string;
};

export default class TransferFeedApi {
  static places(region: number): Promise<TransferPlace[]> {
    return request({ url: `/data/transferPlaces/${region}` });
  }
  static feed(region: number, place: number, before: number | null): Promise<{ items: TransferEntry[]; next: number | null }> {
    return request({ url: `/data/transferFeed/${region}/${place}`, params: before ? { before } : {} });
  }
  static act(region: number, place: number, transfer: number, data: TransferAction): Promise<{ success: boolean }> {
    return request({ url: `/data/transferFeed/${region}/${place}/${transfer}`, method: "POST", data });
  }
  static projects(region: number, date: string): Promise<{ id: number; name: string; number: string }[]> {
    return request({ url: `/data/possibleProjects/${region}/${date}` });
  }
  static recorders(project: number, date: string): Promise<Record<string, string>> {
    return request({ url: `/data/possibleErfasser/${project}/${date}` });
  }
  static locations(recorder: number, date: string): Promise<{ project: Record<string, [string, string]>; specialPlace: Record<string, string> }> {
    return request({ url: `/data/possibleLocations/${recorder}/${date}` });
  }
}
